// Project status / confidence / generic status pill.
const STATUS_STYLES: Record<string, string> = {
  "Under construction": "bg-accent-50 text-accent-700 border-accent/20",
  "Pre-construction": "bg-ink-100 text-ink-700 border-ink-200",
  "In entitlement": "bg-warn-50 text-warn-700 border-warn/20",
  // SOV confidence
  Confirmed: "bg-positive-50 text-positive-700 border-positive/20",
  "Pending Confirmation": "bg-warn-50 text-warn-700 border-warn/20",
  Flagged: "bg-critical-50 text-critical-700 border-critical/20",
  Missing: "bg-ink-100 text-ink-600 border-ink-200",
  Estimate: "bg-ink-100 text-ink-600 border-ink-200",
};

const DEFAULT = "bg-ink-100 text-ink-700 border-ink-200";

export default function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${
        STATUS_STYLES[status] ?? DEFAULT
      }`}
    >
      {status}
    </span>
  );
}
